import {Button, PriorityIcon, Scrollbar, Text} from '@priority-software/priority-style-react';
import React, {useState} from 'react';
import {isRTL} from '../../../Localization';
import styles from '../styles/Messages.module.scss';
import messagesText from '../texts';

export const MoreInfo = ({text, buttonRef}) => {
    const [open, setOpen] = useState(false);

    const arrowIcon = isRTL() ? PriorityIcon.arrowLeft : PriorityIcon.arrowRight;

    return (
        <div className={styles.moreInfoContainer}>
            <Button
                inputRef={buttonRef}
                skin="text"
                onClick={() => setOpen(isOpen => !isOpen)}
                prefixIcon={open ? PriorityIcon.arrowBottom : arrowIcon}
            >
                {open ? messagesText.close : messagesText.moreInfo}
            </Button>
            {open && (
                <Scrollbar autoHeight autoHeightMax={260} autoHide>
                    <Text componentClasses={styles.moreInfoContent}>{text}</Text>
                </Scrollbar>
            )}
        </div>
    );
};
